// src/components/modals/PasswordChangeModal.jsx
// Mirrors the #pwdChgModal in main.asp exactly.

import React, { useState } from 'react';
import api from '../../services/api';
import { useTexts, TXT } from '../../context/TextContext';

export default function PasswordChangeModal({ show, onClose, showToast }) {
  const { t } = useTexts();
  const [form, setForm] = useState({ oldPwd: '', newPwd1: '', newPwd2: '' });
  const [error, setError] = useState('');

  if (!show) return null;

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async () => {
    if (form.newPwd1 !== form.newPwd2) {
      setError('Las contraseñas nuevas no coinciden');
      return;
    }
    if (!form.newPwd1) {
      setError('La nueva contraseña no puede estar vacía');
      return;
    }
    try {
      await api.post('/auth/change-password', {
        oldPassword: form.oldPwd,
        newPassword: form.newPwd1,
      });
      showToast(t(TXT.PASSWORD_CHANGED, 'Contraseña cambiada con éxito'));
      setForm({ oldPwd: '', newPwd1: '', newPwd2: '' });
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al cambiar la contraseña');
    }
  };

  return (
    <div
      className="modal fade show d-block"
      id="pwdChgModal"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t(TXT.CHANGE_PASSWORD, 'Cambio de contraseña')}:</h5>
          </div>
          <div className="modal-body">
            <div className="form-group text-start">
              <label>{t(TXT.OLD_PASSWORD, 'Contraseña anterior')}</label>
              <input
                type="password"
                className="form-control"
                name="oldPwd"
                value={form.oldPwd}
                onChange={handleChange}
              />
            </div>
            <div className="form-group text-start">
              <label>{t(TXT.NEW_PASSWORD, 'Nueva contraseña')}</label>
              <input
                type="password"
                className="form-control"
                name="newPwd1"
                value={form.newPwd1}
                onChange={handleChange}
              />
            </div>
            <div className="form-group text-start">
              <label>{t(TXT.REPEAT_PASSWORD, 'Repetir nueva contraseña')}</label>
              <input
                type="password"
                className="form-control"
                name="newPwd2"
                value={form.newPwd2}
                onChange={handleChange}
              />
            </div>
            {error && (
              <div className="form-group text-danger">
                <label id="log_msgchange">{error}</label>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="button" onClick={onClose}>{t(TXT.CANCEL, 'Cancelar')}</button>
            <button type="button" className="button color1" onClick={handleSubmit}>{t(TXT.CONFIRM, 'Confirmar')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
